import HelpGuide from '../components/HelpGuide';

export default function Help() {
    return (
        <div className="min-h-screen bg-background px-4 py-12 max-w-3xl mx-auto">
            <h1 className="text-3xl font-bold text-foreground mb-2">Mimique Help Guide</h1>
            <HelpGuide />
        </div>
    );
}
